import React from 'react';
import Link from '@/lib/Link';
import * as styles from './footer.module.scss';

interface FooterTypes {}

const Footer: React.FC<FooterTypes> = () => (
  <footer className={styles.lFooter}>
    <small>
      <Link to="https://pivot.jp/" target="_blank">
        &copy;2021 PIVOT Inc.
      </Link>
    </small>
  </footer>
);

export default Footer;
